import React, { useRef, useState } from "react";
import Grid from "../Grid/grid";
import { motion } from "framer-motion";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "swiper/css";

function ImgSection({ product }: { product: any }) {
  const [activeSlide, setActiveSlide] = useState(0);
  const swiperRef = useRef<any>(null);

  if (!product.poster_imgs || product.poster_imgs.length === 0) return null;

  return (
    <div className="relative flex flex-col items-center justify-center py-10 px-4 sm:px-8 lg:px-16 w-full overflow-hidden">
      <Grid size={100} direction="top-center" />
      
      <div className="w-full max-w-7xl flex items-center justify-center relative group/arrows">
        {/* Custom Navigation Left */}
        <button
          onClick={() => {
            if (swiperRef.current) {
              swiperRef.current.slidePrev();
            }
          }}
          className="absolute left-2 sm:left-4 z-20 h-12 w-12 flex items-center justify-center border rounded-full bg-white/90 backdrop-blur-sm border-slate-200 hover:bg-white hover:scale-110 transition-all duration-300 shadow-lg text-slate-700"
          aria-label="Previous slide"
        >
          <ChevronLeft className="h-5 w-5" />
        </button>

        {/* Swiper Slider */}
        <Swiper
          onSwiper={(swiper: any) => {
            swiperRef.current = swiper;
          }}
          onSlideChange={(swiper: any) => {
            setActiveSlide(swiper.realIndex);
          }}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          loop={true}
          modules={[Autoplay, Navigation]}
          className="w-full rounded-2xl overflow-hidden"
        >
          {product.poster_imgs.map((imgSrc: any, index: number) => (
            <SwiperSlide
              key={index}
              className="flex items-center justify-center bg-white"
            >
              <div className="w-full flex items-center justify-center p-1 sm:p-2">
                <img
                  className="w-full aspect-[16/9] max-h-[75vh] object-contain rounded-2xl border border-slate-200/60 shadow-xl bg-slate-50/30"
                  src={imgSrc}
                  alt={`${product.title} screenshot ${index + 1}`}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Navigation Right */}
        <button
          onClick={() => {
            if (swiperRef.current) {
              swiperRef.current.slideNext();
            }
          }}
          className="absolute right-2 sm:right-4 z-20 h-12 w-12 flex items-center justify-center border rounded-full bg-white/90 backdrop-blur-sm border-slate-200 hover:bg-white hover:scale-110 transition-all duration-300 shadow-lg text-slate-700"
          aria-label="Next slide"
        >
          <ChevronRight className="h-5 w-5" />
        </button>
      </div>

      {/* Custom Pagination Dots */}
      <div className="flex justify-center gap-2 mt-6 z-10">
        {product.poster_imgs.map((_: any, index: number) => (
          <button
            key={index}
            onClick={() => {
              if (swiperRef.current) {
                swiperRef.current.slideToLoop(index);
              }
            }}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
              index === activeSlide
                ? "bg-slate-600 scale-125"
                : "bg-slate-300 hover:bg-slate-400"
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

export default ImgSection;
